<template>
  <div 
    id="app"
    :style="{
      '--inner-height': innerHeight
    }">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App',
  data(){
    return {
      innerHeight: `${window.innerHeight}px`
    }
  }
}
</script>

<style lang="scss">
$progress-color: $theme-color;

#nprogress{
  .bar{
    z-index: 3000;
    height: 0.175rem;
  }

  .spinner,
  .spinner-icon{
    width: 1.4rem;
    height: 1.4rem;
    z-index: 3000;
  }

  .spinner-icon{
    border: solid 0.14rem transparent;
    border-top-color: $progress-color;
    border-left-color: $progress-color;
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue